import * as requests from "../coraWebComponents/utils/requests";
import urls from "../constants/Urls";

const buildAA_DEF_OB = (id = "") => {
  return `${urls.AA_DEF_OB}/${id}`;
};

export const getAA_DEF_OB_HODN = async (id) => {
  if (id === 0) {
    return null;
  }

  const url = buildAA_DEF_OB(id);
  try {
    let res = await requests.get(url);
    return res;
  } catch (error) {
    throw error;
  }
};
